import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BoutonPaiementCarte from '../composants/BoutonPaiementCarte';
import BoutonPaiementMobileMoney from '../composants/BoutonPaiementMobileMoney';
import { usePanier } from '../contexte/PanierContexte';
import api from '../services/api';
import { formaterPrix } from '../services/format';

export default function Paiement() {
  const navigate = useNavigate();
  const { items, total, vider } = usePanier();
  const [message, setMessage] = useState('');
  const [erreur, setErreur] = useState('');
  const montant = Number(total || 0);

  const articles = useMemo(() => {
    return items.map((it) => ({
      produit_id: it.produit_id,
      variante_id: it.variante_id,
      quantite: it.quantite
    }));
  }, [items]);

  async function creerCommande({ methode_paiement, paiement_id }) {
    const { data } = await api.post('/commandes', {
      articles,
      methode_paiement,
      paiement_id
    });
    return data;
  }

  async function apresCommande() {
    vider();
    navigate('/mes-commandes');
  }

  if (!items.length) {
    return <div className="rounded-3xl border border-gray-200 bg-white p-8 text-sm text-gray-600">Panier vide.</div>;
  }

  return (
    <div className="grid gap-6 lg:grid-cols-[1fr_420px]">
      <section className="grid gap-4">
        <div>
          <div className="text-xs font-semibold uppercase tracking-widest text-gray-600">Paiement</div>
          <div className="mt-2 text-xl font-bold text-gray-900">Finaliser votre commande</div>
        </div>

        {erreur ? (
          <div className="rounded-2xl border border-rose-200 bg-rose-50 p-4 text-sm text-rose-700">{erreur}</div>
        ) : null}
        {message ? (
          <div className="rounded-2xl border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-700">{message}</div>
        ) : null}

        <BoutonPaiementCarte
          montant={montant}
          devise="eur"
          onPaye={async ({ paiementId, paymentIntent }) => {
            setErreur('');
            try {
              const commande = await creerCommande({ methode_paiement: 'carte', paiement_id: paymentIntent?.id || paiementId });
              setMessage(`Commande #${commande.id} confirmée`);
              await apresCommande();
            } catch (e) {
              setErreur(e?.response?.data?.message || 'Erreur création commande');
            }
          }}
        />

        <div className="rounded-3xl border border-gray-200 bg-white p-6">
          <div className="text-sm font-semibold text-gray-900">Paiement Mobile Money</div>
          <div className="mt-1 text-xs text-gray-600">Connecteurs à configurer selon les APIs Orange Money/Wave.</div>
          <div className="mt-4 grid gap-3">
            <BoutonPaiementMobileMoney
              fournisseur="orange_money"
              montant={montant}
              onResultat={async (r) => {
                setErreur('');
                try {
                  const commande = await creerCommande({ methode_paiement: 'orange_money', paiement_id: r?.resultat?.id || null });
                  setMessage(`Commande #${commande.id} confirmée`);
                  await apresCommande();
                } catch (e) {
                  setErreur(e?.response?.data?.message || 'Erreur création commande');
                }
              }}
            />
            <BoutonPaiementMobileMoney
              fournisseur="wave"
              montant={montant}
              onResultat={async (r) => {
                setErreur('');
                try {
                  const commande = await creerCommande({ methode_paiement: 'wave', paiement_id: r?.resultat?.id || null });
                  setMessage(`Commande #${commande.id} confirmée`);
                  await apresCommande();
                } catch (e) {
                  setErreur(e?.response?.data?.message || 'Erreur création commande');
                }
              }}
            />
          </div>
        </div>
      </section>

      <aside className="h-fit rounded-3xl border border-gray-200 bg-white p-6">
        <div className="text-sm font-semibold text-gray-900">Résumé</div>
        <div className="mt-4 grid gap-2 text-sm text-gray-700">
          {items.map((it) => (
            <div key={`${it.produit_id}-${it.variante_id || 0}`} className="flex items-center justify-between">
              <div className="truncate pr-3">
                {it.nom} <span className="text-gray-400">x{it.quantite}</span>
              </div>
              <div className="font-semibold">{formaterPrix(Number(it.prix_unitaire) * Number(it.quantite))}</div>
            </div>
          ))}
        </div>
        <div className="mt-4 flex items-center justify-between border-t border-gray-200 pt-4 text-sm text-gray-700">
          <div>Total</div>
          <div className="text-lg font-bold text-gray-900">{formaterPrix(montant)}</div>
        </div>
      </aside>
    </div>
  );
}
